import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-sgc-privacy-policy',
    templateUrl: './sgc-privacy-policy.component.html',
    styleUrls: ['./sgc-privacy-policy.component.css'],
    standalone: false
})
export class SgcPrivacyPolicyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
